import { MdOutlinePlayCircle } from "react-icons/md";
import { ResourceName } from "./ResourceName";
import { extractYouTubeVideoId } from "utils/yt";

interface DownloadableResourceProps {
  name: string;
  description: string;
  link: string;
}

export function YouTubeThumbnailResource({ name, description, link }: DownloadableResourceProps) {
  const videoId = extractYouTubeVideoId(link);
  return (
    <>
      <ResourceName name={name} description={description} />

      <div className="mr-9 py-2">
        {videoId ? (
          <YouTubeThumbnail videoId={videoId} />
        ) : (
          <div>Błędny link do filmu YouTube. Upewnij się, że link jest poprawny.</div>
        )}
      </div>
    </>
  );
}

const YouTubeThumbnail: React.FC<{ videoId: string }> = ({ videoId }) => {
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

  return (
    <div className="relative w-full max-w-md cursor-pointer">
      <img src={thumbnailUrl} alt="YouTube Video Thumbnail" className="rounded-lg shadow-lg" />
      <button
        className="absolute inset-0 flex items-center justify-center rounded-lg bg-black bg-opacity-50"
        onClick={() => window.open(`https://www.youtube.com/watch?v=${videoId}`, "_blank")}
      >
        <MdOutlinePlayCircle className="text-white" size={36} />
      </button>
    </div>
  );
};
